import React from 'react';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import { servicesSchema } from './schema';
import { sanitizeServiceUrls } from './servicesUtils';

const ServicesData = (props) => {
  const { block, data, onChangeBlock, blocksErrors } = props;
  const schema = servicesSchema(props);

  const handleChangeBlock = (blockId, value = {}) => {
    const nextValue = {
      ...value,
    };

    if (Object.prototype.hasOwnProperty.call(nextValue, 'serviceUrls')) {
      nextValue.serviceUrls = sanitizeServiceUrls(nextValue.serviceUrls);
    }

    onChangeBlock(blockId, nextValue);
  };

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={handleChangeBlock}
      onChangeField={(id, value) =>
        handleChangeBlock(block, {
          ...data,
          [id]: id === 'serviceUrls' ? sanitizeServiceUrls(value) : value,
        })
      }
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

ServicesData.propTypes = {
  block: PropTypes.string,
  blocksErrors: PropTypes.object,
  data: PropTypes.object,
  onChangeBlock: PropTypes.func,
};

export default ServicesData;
